import { getNextOfKinForm } from '../../../selectors/ugMotorInsurance/nextOfKin';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { getCustomerIdValue, getInsuranceQuotationIdValue } from '../../../selectors/ugMotorInsurance/quote';
import { setShowTaggingErrorModal, setTaggingErrorMessage } from '../../../actions/ugMotorInsurance/quote';
import { setNextOfKinSubmittedValue } from '../../../actions/ugMotorInsurance/nextOfKin';
import { collectLoginDetails } from '../../../actions/ugMotorInsurance/auth';
import { navigateToCarDetails } from '../../../actions/ugMotorInsurance/routing';
import { setSelectedFormValue } from '../../../actions/ugMotorInsurance/carDetails';

export const nextOfKinSubmitService = async (store, next, action) => {
    const state = store.getState();

    if (getIsApiPending(state)) {
        return next(action);
    }

    store.dispatch(setShowTaggingErrorModal(false));
    store.dispatch(setTaggingErrorMessage(null));
    store.dispatch(apiTransitionPayloadCollection.pending());
    try {
        await makeSubmission(store.getState());

        store.dispatch(setNextOfKinSubmittedValue(true));

        store.dispatch(navigateToCarDetails());
        store.dispatch(setSelectedFormValue('carDetails'));
    } catch (error) {
        console.error(error);

        store.dispatch(setNextOfKinSubmittedValue(false));
        const status = error?.response?.status;

        if (status === 401) {
            store.dispatch(collectLoginDetails());
        }

        store.dispatch(setTaggingErrorMessage('Something went wrong. Try again later'));
        store.dispatch(setShowTaggingErrorModal(true));
    } finally {
        store.dispatch(apiTransitionPayloadCollection.initial());
    }

    return next(action);
};

const payloadCollection = (state) => {
    const nextOfKin = getNextOfKinForm(state);

    const customerId = getCustomerIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    const nextOfKinPayload = {
        customerId: customerId.value,
        quotationId: insuranceQuotationId.value,
        nextOfKinIdNumber: nextOfKin.idNumber.value || 'N/A',
        nextOfKinEmail: nextOfKin.email.value || 'N/A',
        nextOfKinRelationship: nextOfKin.relationship.value || 'N/A',
        nextOfKinPostalAddress: nextOfKin.postalAddress.value || 'N/A',
        nextOfKinNames: `${nextOfKin?.firstName?.value} ${nextOfKin?.lastName?.value}`,
    };

    return {
        ...nextOfKinPayload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/submit/next-of-kin';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
